import { buildUrl } from 'domain/Api';
import { createApiActionCreator, ApiCall } from 'omni-common-ui';

const ACTION_OBJECT_NAME = 'ESSAY';
export const FETCH_ESSAY_REQUEST = `FETCH_${ACTION_OBJECT_NAME}_REQUEST`;
export const FETCH_ESSAY_SUCCESS = `FETCH_${ACTION_OBJECT_NAME}_SUCCESS`;
export const FETCH_ESSAY_FAILURE = `FETCH_${ACTION_OBJECT_NAME}_FAILURE`;

const DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };
const buildEssayUrl = (id, studentId) =>
  buildUrl(`/writing-assignment-activities/${id}/essay?studentId=${studentId}`);
const createFetchEssayActions = (id, studentId) =>
createApiActionCreator(
  ACTION_OBJECT_NAME,
  buildEssayUrl(id, studentId),
  'GET',
  DISABLE_DEFAULT_ACTION_EXTRAS,
  { id, studentId },
  DISABLE_DEFAULT_ACTION_EXTRAS
);


export const fetchEssay = (id, studentId) =>
  createFetchEssayActions(id, studentId);

export function fetchEssayIfNeeded(id, studentId) {
  const method = 'GET';
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method, url: buildEssayUrl(id, studentId) })) {
      return false;
    }

    return dispatch(fetchEssay(id, studentId));
  };
}



// WEBPACK FOOTER //
// ./data/WritingAssignment/Essay/actions.js